import { ReactNode } from 'react';

export const LoanSummaryShell = ({
    desktop,
    mobile
}: {
    desktop: ReactNode;
    mobile: ReactNode;
}) => (
    <div data-testid="loan-summary" className="min-m:h-full">
        <div className="hidden min-m:block min-m:h-full">{desktop}</div>
        <div className="min-m:hidden">{mobile}</div>
    </div>
);
